import { map, Observable } from 'rxjs';

import { Component, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, FormsModule, NgForm, NgModelGroup } from '@angular/forms';

import { IPersonalGroup } from 'app/models/filter-form.models';
import { FilterService } from 'app/services/filter.service';
import { makeControlDirty } from 'app/utils/form.utils';
import { IAutocompleteOption } from 'app/models/filter.models';
import { FilterItemComponent } from '../../filter-item/filter-item.component';
import { AutocompleteComponent } from '../../../form/autocomplete/autocomplete.component';

@Component({
  selector: 'app-personal-tab',
  templateUrl: './personal-tab.component.html',
  styleUrls: ['./personal-tab.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  imports: [FormsModule, FilterItemComponent, AutocompleteComponent],
})
export class PersonalTabComponent implements OnInit {
  @ViewChild('personal') ngModelGroup!: NgModelGroup;

  personalGroup: IPersonalGroup = {
    officer: {
      id: undefined,
      value: undefined,
    },
  };

  constructor(private filterService: FilterService) {}

  ngOnInit(): void {
    const { appliedFilters: filters } = this.filterService;

    if (!filters.personalFilter) return;

    const { officerId, officerName } = filters.personalFilter;

    if (officerId) {
      this.personalGroup = {
        officer: {
          id: officerId.toString(),
          value: officerName ?? '',
        },
      };
    }
  }

  get personalValue() {
    return this.personalGroup?.officer?.value ?? '';
  }

  filter = (search: string): Observable<IAutocompleteOption[]> => {
    return this.filterService.getOfficers(search).pipe(
      map(({ content }) =>
        content.map(({ id, firstName, middleName, lastName }) => ({
          id: id.toString(),
          value: [firstName, middleName, lastName].filter((x) => x).join(' '),
        })),
      ),
    );
  };

  clearFilter(): () => void {
    return () => {
      makeControlDirty(this.ngModelGroup.control);

      this.personalGroup = {
        officer: {
          id: undefined,
          value: undefined,
        },
      };
    };
  }
}
